import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// Components
import { translateComponent } from "../../utils/services/translate";

// REDUX
import { setShowNavigationMenu } from "../../redux/actions";


const AccordionButtonComponent = ({ children }) => {
  const language = useSelector((state) => state.Layout.language);
  const translations = useSelector((state) => state.Layout.translations);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function BuyTicket(navigate, dispatch) {
    dispatch(setShowNavigationMenu(false));
    navigate("/");
  }

  return (
    <button
      className="btn btn-success w-100 text-lg"
      onClick={() => BuyTicket(navigate, dispatch)}
    >
      {translateComponent(
        translations,
        language,
        "navigationMenu",
        "buyNewTicketButton"
      )}
    </button>
  );
};

export default AccordionButtonComponent;
